import { Form } from 'react-aria-components'

import { css } from '@portal/styled-system/css'

import { useI18n } from '@/shared/lib/i18n'
import { Button, CancelButton, Modal, TextArea } from '@/shared/ui'

import type { MessageReportDialogProps } from './view'

export function StepTwo(props: MessageReportDialogProps) {
    const { i18n } = useI18n()

    return (
        <Modal.Body styles={css.raw({ gap: '3' })}>
            <div>{i18n.CHAT_REPORT_STEP02_DESCR}</div>
            <Form
                method="post"
                onSubmit={(evt) => {
                    evt.preventDefault()
                    const formData = new FormData(evt.currentTarget as HTMLFormElement)

                    props.onReportButtonClick({
                        reason_message: (formData.get('message') as string) ?? '',
                    })
                }}
                className={css({ width: 'full' })}
            >
                <TextArea
                    name="message"
                    rows={4}
                    placeholder={i18n.CHAT_REPORT_PLACEHOLDER}
                    isDisabled={props.nonInteractive}
                />
                <Modal.Buttons styles={css.raw({ justifyContent: 'flex-end', padding: '0', paddingTop: '2' })}>
                    <CancelButton styles={css.raw({ width: 'auto' })} onPress={props.onBackButtonClick}>
                        {i18n.BTN_BACK}
                    </CancelButton>
                    <Button
                        type="submit"
                        color="success"
                        styles={css.raw({ width: 'auto' })}
                        isDisabled={props.nonInteractive}
                    >
                        {i18n.CHAT_REPORT_BTN}
                    </Button>
                </Modal.Buttons>
            </Form>
        </Modal.Body>
    )
}
